<template>
  <v-icon v-show="isShowSyncIcon" color="#0000f8" :size="$attrs.size" class="sync-progress"> mdi-sync </v-icon>
</template>

<script>
export default {
  data() {
    return {
      isShowSyncIcon: false,
    };
  },
  methods: {
    trigger() {
      if (this._isShowSyncIconTimeout) {
        clearTimeout(this._isShowSyncIconTimeout);
      }

      this.isShowSyncIcon = true;
      this._isShowSyncIconTimeout = setTimeout(() => {
        this.isShowSyncIcon = false;
      }, 500);
    },
  },
};
</script>

<style scoped>
.sync-progress {
  -webkit-animation: spin 2s linear infinite;
  -moz-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
